
define('ldsh!modules/page_generator/templates/generator_page', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<!DOCTYPE html>\n<html>\n<head>\n  <!-- seo stuff -->\n  <title>' +
((__t = ( seo.title )) == null ? '' : __t) +
'</title>\n  <meta http-equiv="Content-Type" content="text/html;charset=UTF-8" />\n  <meta charset="UTF-8" />\n  <meta name="description" content="' +
((__t = ( seo.description )) == null ? '' : __t) +
'" />\n  <meta name="keywords" content="' +
((__t = ( seo.keywords )) == null ? '' : __t) +
'" />\n  ';
 if (seo.robots) { ;
__p += '<meta name="robots" content="' +
((__t = ( seo.robots )) == null ? '' : __t) +
'" />';
 } ;
__p += '\n  ';
 if (seo.canonicalEnabled && seo.canonicalEnabled === 'true' && seo.canonicalURL) { ;
__p += '\n  <link rel="canonical" href="' +
((__t = ( seo.canonicalURL )) == null ? '' : __t) +
'" />\n  ';
 } ;
__p += '\n  ';
 _.each(seo.customMeta, function(customMeta){ ;
__p += '\n  <meta ' +
((__t = ( (/^og\:/.test(customMeta.name)) ? 'property' : 'name' )) == null ? '' : __t) +
'="' +
((__t = ( customMeta.name )) == null ? '' : __t) +
'" content="' +
((__t = ( customMeta.value )) == null ? '' : __t) +
'" />\n  ';
 }) ;
__p += '\n  <meta name="viewport" content="width=device-width,initial-scale=1">\n\n  <!-- default styles/scripts -->\n  <link rel="stylesheet" href="/lpg/public/templates.min.css" />\n\n  ';
 if(headScripts){ ;
__p += '\n  <script src="' +
((__t = (jQueryURL )) == null ? '' : __t) +
'"></script>\n  ';
 } ;
__p += '\n\n  <!-- google fonts -->\n  <link href="' +
((__t = ( fonts )) == null ? '' : __t) +
'" rel="stylesheet" type="text/css">\n\n  <!--page properties -->\n  <style type="text/css">\n  body {\n    background-color: ' +
((__t = ( pageProperties.backgroundColor )) == null ? '' : __t) +
';\n    color: ' +
((__t = ( pageProperties.color )) == null ? '' : __t) +
';\n    font-family: "' +
((__t = ( pageProperties.fontFamily )) == null ? '' : __t) +
'";\n  }\n  a, a:link {\n    color: ' +
((__t = ( pageProperties.linkColor )) == null ? '' : __t) +
';\n  }\n  .wrapper {\n    width: ' +
((__t = ( pageProperties.width )) == null ? '' : __t) +
'px;\n    margin-top: ' +
((__t = ( pageProperties.marginTop )) == null ? '' : __t) +
'px;\n    /*opacity: ' +
((__t = ( pageProperties.opacity / 100 )) == null ? '' : __t) +
';*/\n  }\n  .lpg-page {\n    min-width: ' +
((__t = ( pageProperties.width )) == null ? '' : __t) +
'px;\n  }\n  </style>\n\n  <!-- element styles -->\n  <style type="text/css">\n  ' +
((__t = ( elementStyles )) == null ? '' : __t) +
'\n  </style>\n   <!-- variant styles -->\n  ' +
((__t = ( styles )) == null ? '' : __t) +
'\n  ' +
((__t = ( headScripts )) == null ? '' : __t) +
'\n  ';
 if (googleReCaptchaSiteKey && googleReCaptchaURL) { ;
__p += '\n  <script src="' +
((__t = ( googleReCaptchaURL )) == null ? '' : __t) +
'" async defer></script>\n  ';
 } ;
__p += '\n</head>\n<body ' +
((__t = ( !isContent ? 'class="page-confirm"' : '')) == null ? '' : __t) +
'>\n  <div id="fb-root"></div>\n  <!-- body contents -->\n  <div class="wrapper lpg-page">\n    ' +
((__t = ( content )) == null ? '' : __t) +
'\n  </div>\n\n  ';
 if(isContent) { ;
__p += '\n    <!-- privacy warning -->\n    ';
 if(privacy.active) { ;
__p += '\n      <div class="cookies-strip js-privacy ' +
((__t = ( (platform === 'mobile')? 'cookies-mobile' : '' )) == null ? '' : __t) +
'">\n        <span class="close js-privacy-close"></span>\n        <h2>' +
((__t = ( privacy.title )) == null ? '' : __t) +
'</h2>\n        <p>' +
((__t = ( privacy.message )) == null ? '' : __t) +
'\n        <a href="' +
((__t = (privacy.linkUrl )) == null ? '' : __t) +
'" class="cookies-policy-link">' +
((__t = ( privacy.linkText )) == null ? '' : __t) +
'</a>\n        </p>\n      </div>\n    ';
 } ;
__p += '\n    <!-- validation summary -->\n    <div class="form-validation-overlay js-lpg-validation" style="display:none">\n      <span class="close"></span>\n      <h2>' +
((__t = ( errorMessage )) == null ? '' : __t) +
'</h2>\n      <ul class="js-lpg-error-list"></ul>\n    </div>\n    <!-- /validation summary -->\n    ';
 if(!headScripts){ ;
__p += '\n    <script src="' +
((__t = (jQueryURL )) == null ? '' : __t) +
'"></script>\n    ';
 } ;
__p += '\n\n    <script src="/lpg/public/lpg_pub.min.js?v=6"></script>\n\n    ';
 _.each(externalPublicLibs, function(lib) { ;
__p += '\n    <script src="/lpg/public/' +
((__t = ( lib )) == null ? '' : __t) +
'.js"></script>\n    ';
 }) ;
__p += '\n\n    ';
 if (linkedinAppId) { ;
__p += '\n    <script type="text/javascript" src="//platform.linkedin.com/in.js">\n      api_key: ' +
((__t = ( linkedinAppId )) == null ? '' : __t) +
'\n      onLoad: LPGRuntime.onLinkedInLogin\n      lang: ' +
((__t = ( isoLanguage )) == null ? '' : __t) +
'\n    </script>\n    ';
 } ;
__p += '\n    <script type="text/javascript">\n    LPGRuntime.init({\n      lpgIsPreview: false,\n      lpgCookies: ' +
((__t = ( privacy.active )) == null ? '' : __t) +
',\n      errorMessage: "' +
((__t = ( errorMessage )) == null ? '' : __t) +
'",\n      appId: "' +
((__t = ( facebookAppId )) == null ? '' : __t) +
'",\n      idaf: "{{idaf}}"\n    });\n    </script>\n  ';
 } else if (!headScripts) { ;
__p += '\n  <script src="' +
((__t = (jQueryURL )) == null ? '' : __t) +
'"></script>\n  ';
 } ;
__p += '\n  <!-- variant scripts -->\n  ' +
((__t = ( scripts )) == null ? '' : __t) +
'\n  <!-- social api scripts for share buttons -->\n  ' +
((__t = ( socialScripts )) == null ? '' : __t) +
'\n  ';
 if (facebookAppId) { ;
__p += '\n  <script id="facebook-jssdk" src="//connect.facebook.net/en_US/sdk.js#xfbml=1&version=v2.0"></script>\n  ';
 } ;
__p += '\n  <script src="{{pixel_url}}"></script>\n  ' +
((__t = ( pixels )) == null ? '' : __t) +
'\n</body>\n</html>\n';

}
return __p
};});

